import '@/css/tailwind.css'

import {createApp} from 'vue/dist/vue.esm-bundler';
import AppLayout from "./components/app/AppLayout.vue";
import NewQRCodeForm from "./components/app/qrcodes/form/NewQRCodeForm.vue";
import {createPinia} from 'pinia'

import VueApexCharts from "vue3-apexcharts";
import applyCaseMiddleware from 'axios-case-converter';
import axios from 'axios'
import Notifications from 'notiwind'
import mitt from 'mitt';
import QrCodeList from "@/scripts/components/app/qrcodes/list/QrCodeList.vue";
import QrCodeForm from "@/scripts/components/app/qrcodes/form/QrCodeForm.vue";
import Loader from "@/scripts/components/app/common/Loader.vue";
import TitleEditor from "@/scripts/components/app/qrcodes/one/TitleEditor.vue";
import VButton from "@/scripts/components/app/common/VButton.vue";
import VNotification from "@/scripts/components/app/common/VNotification.vue";
import Dashboard from "@/scripts/components/app/analytics/Dashboard.vue";
import Filters from "@/scripts/components/app/analytics/Filters.vue";
import ShortStats from "@/scripts/components/app/analytics/ShortStats.vue";
import QrCodeScansTrends from "@/scripts/components/app/analytics/QrCodeScansTrends.vue";
import QrCodeDeviceTrends from "@/scripts/components/app/analytics/QrCodeDeviceTrends.vue";
import QrCodeCitiesTrends from "@/scripts/components/app/analytics/QrCodeCitiesTrends.vue";
import VAccountSettings from "@/scripts/components/app/account/VAccountSettings.vue";
import Toast from "vue-toastification";
import VLogin from "@/scripts/components/app/auth/VLogin.vue";
import VLostPassword from "@/scripts/components/app/auth/VLostPassword.vue";
import VResetPassword from "@/scripts/components/app/auth/VResetPassword.vue";
import VBilling from "./components/app/billing/VBilling.vue";
import {useAccount} from "./store/account";
import useLoading from "./store/loading";
import VBatchQrForm from "./components/app/qrcodes/batch/VBatchQrForm.vue";
import VWarning from "./components/app/common/VWarning.vue";
import VSuccess from "./components/app/common/VSuccess.vue";

window.axios = applyCaseMiddleware(axios)

const app = createApp({
    async created() {
        const account = useAccount();
        const loading = useLoading();

        loading.isLoading = true
        await account.getAccount()
        loading.isLoading = false
    }
})

const emitter = mitt();

app.config.globalProperties.emitter = emitter;
app.provide('emitter', emitter)


app.component('AppLayout', AppLayout)
app.component('NewQrCodeForm', NewQRCodeForm)
app.component('QrCodeForm', QrCodeForm)
app.component('QrCodeList', QrCodeList)
app.component('Loader', Loader)
app.component('TitleEditor', TitleEditor)
app.component('VButton', VButton)
app.component('VNotification', VNotification)
app.component('Dashboard', Dashboard)
app.component('Filters', Filters)
app.component('ShortStats', ShortStats)
app.component('QrCodeScansTrends', QrCodeScansTrends)
app.component('QrCodeDeviceTrends', QrCodeDeviceTrends)
app.component('QrCodeCitiesTrends', QrCodeCitiesTrends)
app.component('VAccountSettings', VAccountSettings)
app.component('VLogin', VLogin)
app.component('VLostPassword', VLostPassword)
app.component('VResetPassword', VResetPassword)
app.component('VBilling', VBilling)
app.component('VBatchQrForm', VBatchQrForm)
app.component('VWarning', VWarning)
app.component('VSuccess', VSuccess)
app.use(VueApexCharts);

app.use(createPinia())
app.use(Notifications)
app.use(Toast);

app.mount('#app')